// extracted by mini-css-extract-plugin
export var formContainer = "_he-0";
export var message = "_he-1";